export const SUMMARY_EMPTY_STATE_DELETED =
  'This meeting\'s summary is no longer\navailable.';

export const SUMMARY_EMPTY_STATE_UNAVAILABLE =
  'No summary is available for this meeting.\nPlease enable transcription during the\nmeeting to generate one.';

export const SUMMARY_EMPTY_STATE_PENDING =
  'Your meeting summary is being generated.\nPlease wait…';

export const SUMMARY_EMPTY_STATE_FAILED =
  'Your meeting summary hasn\'t been generated yet.\nPlease click the button below to generate it.';

export const SUMMARY_TOPIC_EMPTY_PLACEHOLDER =
  'No relevant information or conclusions were identified for this topic.';